import React, { createContext, useContext, useState, useEffect } from 'react';
import matterportService from '../services/matterportService';

const LoadingContext = createContext({
  isLoaded: false,
  setIsLoaded: () => {},
});

export const LoadingProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleAutoNavigation = () => {
      // Dispatch a custom event that ChatContext can listen to
      window.dispatchEvent(new CustomEvent('autoNavigationComplete'));
    };

    matterportService.addEventListener('autoNavigationComplete', handleAutoNavigation);

    return () => {
      matterportService.removeEventListener('autoNavigationComplete', handleAutoNavigation);
    };
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoaded, setIsLoaded }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
}; 